module.exports = __webpack_public_path__ + "static/media/lens.b3c681a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lens.svg
// module id = 1219
// module chunks = 0